import { Component, computed, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { JobTaskTemplateMap } from '@app/shared/models/otap.upgrade.interface';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

export type AddJobDialogData = {
  mode: FORM_TYPE;
  jobTaskTemplate: JobTaskTemplateMap;
};

export type DialogResult = {
  formValue: { name: string; jobTaskTemplate: JobTaskTemplateMap };
};

@Component({
  selector: 'app-create-jobs-dialog',
  templateUrl: './create-jobs-dialog.component.html',
  styleUrls: ['./create-jobs-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton
  ]
})
export class CreateJobsDialogComponent {
  private readonly fb = inject(FormBuilder);
  private readonly data = inject<AddJobDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<CreateJobsDialogComponent>);

  readonly mode = this.data.mode;
  readonly jobTaskTemplate = this.data.jobTaskTemplate;
  readonly addJobForm: FormGroup = this.fb.group({
      name: ['', [Validators.required, this.emptyNameValidator(), Validators.minLength(3)]],
      jobTaskTemplateName: ['', Validators.required]
    });
  readonly jobTaskTemplateNameArray = computed(() => Object.values(this.jobTaskTemplate));

  emptyNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const isEmpty = !value || value.trim().length === 0;
      return isEmpty ? { emptyName: true } : null;
    };
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.addJobForm.invalid) {
      return;
    }
    const formValue = this.addJobForm.value;
    const selectedJobTaskTemplateKey = this.getJobTaskTemplateKeyByValue(formValue.jobTaskTemplateName);
    formValue.jobTaskTemplate = selectedJobTaskTemplateKey;
    this.dialogRef.close({ formValue });
  }

  private getJobTaskTemplateKeyByValue(value: string): string {
    const foundEntry = Object.entries(this.jobTaskTemplate).find(([, enumValue]) => enumValue === value);
    return foundEntry ? foundEntry[0] : '';
  }
}

export enum FORM_TYPE {
  ADD
}
